// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface StatusUpdatePayload
 */
export interface StatusUpdatePayload {
    /**
     * Updated name of the status
     * @type {string}
     * @memberof StatusUpdatePayload
     */
    name?: string;
    /**
     * Optional description of the status
     * @type {string}
     * @memberof StatusUpdatePayload
     */
    description?: string;
    /**
     * Updated priority order of the status (lower number = higher priority)
     * @type {number}
     * @memberof StatusUpdatePayload
     */
    priority?: number;
    /**
     * Whether this status is active and available for use
     * @type {boolean}
     * @memberof StatusUpdatePayload
     */
    isActive?: boolean;
    /**
     * Updated color code associated with this status
     * @type {string}
     * @memberof StatusUpdatePayload
     */
    color?: string;
    /**
     * Whether to ignore this result in calculations and reports
     * @type {boolean}
     * @memberof StatusUpdatePayload
     */
    ignoreResult?: boolean;
    /**
     * Whether to enable the option to report a bug for this status
     * @type {boolean}
     * @memberof StatusUpdatePayload
     */
    enableReportBug?: boolean;
}

export function StatusUpdatePayloadFromJSON(json: any): StatusUpdatePayload {
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'isActive': !exists(json, 'is_active') ? undefined : json['is_active'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'ignoreResult': !exists(json, 'ignore_result') ? undefined : json['ignore_result'],
        'enableReportBug': !exists(json, 'enable_report_bug') ? undefined : json['enable_report_bug'],
    };
}

export function StatusUpdatePayloadToJSON(value?: StatusUpdatePayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'description': value.description,
        'priority': value.priority,
        'is_active': value.isActive,
        'color': value.color,
        'ignore_result': value.ignoreResult,
        'enable_report_bug': value.enableReportBug,
    };
}


